export const baseUrl = "https://megt.megtlogistics.com/api/v1";
export const agentsLogin = "agent/login";
export const agentsRegister = "agent/register";
export const agentsUpdateProfile = (userId) => `agent/${userId}/update-profile`;
export const agentsProfile = (userId) => `agent/${userId}/profile`;
export const agentsChangePassword = (userId) => `agent/${userId}/change-password`;
export const agentsLogOut = (userId) => `agent/${userId}/logout`;
export const lang = localStorage.getItem("i18nextLng");
